/**
 * Copyright 2026 Bluecircle Technologies Pvt Limited. All rights reserved.
 *
 * This software and its source code are the proprietary and confidential
 * intellectual property of Bluecircle Technologies Pvt Limited. Unauthorized
 * copying, reproduction, distribution, modification, public display, or use
 * of this software, in whole or in part, is strictly prohibited without the
 * prior written permission of Bluecircle Technologies Pvt Limited.
 *
 * Portions derived from Grist (Copyright Grist Labs), used under the Apache
 * License, Version 2.0. See the NOTICE file for details.
 */

/**
 * A link that has a clickable area that spans the entire containing block.
 *
 * Don't forget to apply the `position: relative` CSS property to the parent block you want the link to cover.
 *
 * @see https://getbootstrap.com/docs/5.3/helpers/stretched-link
 */
import { styled } from "grainjs";

export const stretchedLink = styled("a", `
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &::after {
    position: absolute;
    inset: 0;
    content: '';
    z-index: 1;
  }
`);
